module.exports = __webpack_public_path__ + "media/assets/fonts/Helvetica-Light-6e816f786a7f97793401d5112200c151.ttf";